<template>
  <el-container>
    <el-main   class="main-center">
        <el-form :label-position='labelPosition' :model='formRegister' :rules='rules' label-width='120px'  size='mini'  ref='formRegister'>
          <el-form-item label='公司名称'  prop ='companyname'>
            <el-col :span='17'>
              <el-autocomplete
                v-model="formRegister.companyname"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                :trigger-on-focus="false"
                @select="handleSelect"
                style='width:100%'
              ></el-autocomplete>
            </el-col>
          </el-form-item>
          <el-form-item label='用户名'  prop ='account'>
            <el-col :span='17'>
              <el-input v-model='formRegister.account' @change="validate" ></el-input>
            </el-col>
            <el-col :span='8'>
              <span>{{message}}</span>
            </el-col>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-col :span='17'>
            <el-input type="password" v-model="formRegister.password" autocomplete="off"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkpassword">
            <el-col :span='17'>
            <el-input type="password" v-model="formRegister.checkpassword" autocomplete="off"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label='手机号'  prop ='phonenumber'>
            <el-col :span='17'>
              <el-input v-model='formRegister.phonenumber' @change="validatePhone" ></el-input>
            </el-col>
            <el-col :span='8'>
              <span>{{phonemessage}}</span>
            </el-col>
          </el-form-item>
          <el-form-item label='备注'  prop ='realname'>
            <el-col :span='17'>
              <el-input v-model='formRegister.realname' ></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label='请选择'  prop ='productId'>
          <el-col :span='17'>
            <el-radio v-model="formRegister.productId" label="1">消防水桶</el-radio>
            <el-radio v-model="formRegister.productId" label="2">清洗喷枪</el-radio>
          </el-col>
          </el-form-item>
          <el-form-item label="天空端sn" v-if="formRegister.productId == 1" prop ='sn11'>
            <el-col :span='17'>
            <el-input v-model="formRegister.sn11" placeholder="请输入天空端"></el-input>
            </el-col>
          </el-form-item>
          <el-form-item label="产品唯一标识" v-if="formRegister.productId == 1" prop ='udid'>
            <el-col :span='17'>
              <el-input v-model="formRegister.udid" placeholder="产品唯一标识"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="遥控器SN" v-if="formRegister.productId == 2" prop ='sn1'>
            <el-col :span='17'>
            <el-input v-model="formRegister.sn1" placeholder="请输入遥控器SN"></el-input>
            </el-col>
          </el-form-item>

          <!-- 当包含 '2' 时显示 SN2、SN3 -->
          <el-form-item label="飞机SN" v-if="formRegister.productId == 2" prop ='sn2'>
            <el-col :span='17'>
            <el-input v-model="formRegister.sn2" placeholder="请输入飞机SN"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item label="水枪SN" v-if="formRegister.productId == 2" prop ='sn3'>
            <el-col :span='17'>
            <el-input v-model="formRegister.sn3" placeholder="请输入水枪SN"></el-input>
            </el-col>
          </el-form-item>

          <el-form-item>
            <el-col :span='17'>
              <el-button type='primary' @click='save(formRegister)'>保存</el-button>
              <el-button plain @click='reset'>重置</el-button>
            </el-col>
          </el-form-item>
        </el-form>
    </el-main>
  </el-container>
</template>

<script>
import axios from '../../../utils/request'

export default {
  data () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.formRegister.checkpassword !== '') {
          this.$refs.formRegister.validateField('checkpassword')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formRegister.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      formRegister: {
        companyname: '',
        account: '',
        password: '',
        phonenumber: '',
        checkpassword: '',
        realname: '',
        sn1: '',
        sn2: '',
        sn3: '',
        productId: ''
      },
      radio: 0,
      rules: {
        password: [
          {required: true, validator: validatePass, trigger: 'blur'}
        ],
        checkpassword: [
          {required: true, validator: validatePass2, trigger: 'blur'}
        ],
        companyname: [
          {required: true, message: '请填公司名', trigger: 'change'}
        ],
        account: [
          {required: true, message: '请填写用户名', trigger: 'change'}
        ],
        sn11: [
          {required: true, message: '请填sn1', trigger: 'change'}
        ],
        sn1: [
          {required: true, message: '请填sn1', trigger: 'change'}
        ],
        sn2: [
          {required: true, message: '请填sn2', trigger: 'change'}
        ],
        sn3: [
          {required: true, message: '请填sn3', trigger: 'change'}
        ],
        udid: [
          {required: true, message: '请填产品唯一标识符', trigger: 'change'}
        ]
      },
      companynames: []
    }
  },
  mounted () {
    this.loading()
  },
  methods: {
    save: function (formRegister) {
      let params = this.formRegister
      console.log(params)
      this.$refs.formRegister.validate((valid) => {
        if (valid) {
          axios.put('/register/account', params).then(res => {
            console.log('success')
            this.$router.push('/success')
          })
        }
      })
    },
    querySearch (queryString, cb) {
      var companynames = this.companynames
      var results = queryString ? companynames.filter(this.createFilter(queryString)) : companynames
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter (queryString) {
      return (company) => {
        return (company.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
      }
    },
    validate (val) {
      axios.get(`/data/account/validate?account=${val}`).then(res => {
        console.log('message', res)
        this.message = res.data
        if (this.message === '该用户名可用') {
          this.state = 1
        }
      })
    },
    loading: function () {
      axios.get('/data/account/getCompanyname').then(res => {
        this.companynames = res.data
        console.log('this.companynames', this.companynames)
      })
    },
    validatePhone (val) {
      axios.get(`/data/account/validatephone?phone=${val}`).then(res => {
        console.log('message', res)
        this.phonemessage = res.data
      })
    }
  }
}
</script>

<style scoped>
  .el-container {
    height: 100%;
  }
  .main-center {
    width: 200vw;
    display: flex;
    justify-content: center;    /* 水平居中 */
    align-items: center;        /* 垂直居中 */
    height: 100vh;              /* 占满全屏 */
    padding: 0 !important;
  }
  .div-form{
    width: 500px;               /* 表单宽度，可自行调整 */
    padding: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/table/register/register.vue